<div class="content" role="main">
  <app-hud [displaySocialLinks]="false"></app-hud>
  <div style="min-height: 100vh; background-image: url(assets/assets_web_2/bg-dashboard.webp); background-position: bottom; position: relative; background-repeat: no-repeat; background-size: cover; padding-top: 75px ">
    <div class="col text-center">
      <div class="py-4 py-sm-2">
        <h1 class="my-auto" id="title">Pre-Order</h1>
      </div>


      @if (shopDisabled) {
        <div style="margin-left: auto; margin-right: auto">
          <div style="text-align:center" class="alert alert-danger" role="alert">
            Shop disabled for now.
          </div>
          <div class="container">
            <div class="row">
              <div class="col text-center">
                <button routerLink="/" class="btn btn-primary">Home</button>
              </div>
            </div>
          </div>
        </div>
      }

      @if (success === true) {
        <div class="alert alert-light small p-2">
          Thank you for your purchase
        </div>
      }
      @if (!shopDisabled) {
        <div class="d-flex justify-content-center">
          <app-products-templated-list [products]="listProducts" [productSortType]="currentSortType" style="width: 100vw; max-width: 1770px">
          </app-products-templated-list>
        </div>
      }

    </div>
  </div>
  <div class="d-flex justify-content-center ">
    <p class="px-3 px-lg-0 py-5" style="text-align:center">SoulCast is a game currently in <strong>development phase.</strong><br /> Support us by buying one of our supporter packs.<br /> Gain exclusive access to the game, earn exclusive cosmetics.<br />Become a SoulCaster!</p>
  </div>
  <app-footer></app-footer>
</div>
